// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicSuburbanV1GetOffersHistoryRequest,
  TPublicSuburbanV1GetOffersHistoryModel,
  IMappers,
  TPublicSuburbanV1GetOffersHistoryResponse,
  IPublicSuburbanV1GetOffersHistoryResponse,
  IPublicSuburbanV1GetOffersHistoryResponseError,
} from './types';

export const defaultConfig: TPublicSuburbanV1GetOffersHistoryModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/suburban/v1/get-offers-history/',
} as TPublicSuburbanV1GetOffersHistoryModel;

export function createPublicSuburbanV1GetOffersHistoryModel(
  parameters: IPublicSuburbanV1GetOffersHistoryRequest,
): TPublicSuburbanV1GetOffersHistoryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicSuburbanV1GetOffersHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1GetOffersHistoryRequest;
}

export async function fetchPublicSuburbanV1GetOffersHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1GetOffersHistoryOptions<TResponse200, TResponse400>): Promise<
  TPublicSuburbanV1GetOffersHistoryResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicSuburbanV1GetOffersHistoryModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicSuburbanV1GetOffersHistoryResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicSuburbanV1GetOffersHistoryResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicSuburbanV1GetOffersHistoryResponse;
}
